module.exports = __webpack_public_path__ + "img/exam (5).5ceaac74.png";